import { render } from "./CarCombo.vue?vue&type=template&id=2262ed5b&scoped=true"
import script from "./CarCombo.vue?vue&type=script&lang=js"
export * from "./CarCombo.vue?vue&type=script&lang=js"

import "./CarCombo.vue?vue&type=style&index=0&id=2262ed5b&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2262ed5b"]])

export default __exports__